const GuiDesktop = {
  init(config) {
    this.config = config;

    this.guiDesktop = document.querySelector('#gui-desktop');
    this.playBtn = document.querySelector('#gui-desktop-play');
    this.autoGameBtn = document.querySelector('#gui-desktop-auto-game');
    this.autoGameCancelBtn = document.querySelector('#gui-desktop-auto-game-cancel');
    this.doubleBtn = document.querySelector('#gui-desktop-double');
    this.stopBtn = document.querySelector('#gui-desktop-stop');
    this.rulesBtn1 = document.querySelector('#gui-desktop-rules-1');
    this.rulesBtn2 = document.querySelector('#gui-desktop-rules-2');
    this.linesDownBtn = document.querySelector('#gui-desktop-lines-down');
    this.linesUpBtn = document.querySelector('#gui-desktop-lines-up');
    this.betDownBtn = document.querySelector('#gui-desktop-bet-down');
    this.betUpBtn = document.querySelector('#gui-desktop-bet-up');
    this.maxBetBtn = document.querySelector('#gui-desktop-max-bet');

    this.bet = document.querySelector('#gui-desktop-bet');
    this.lines = document.querySelector('#gui-desktop-lines');
    this.balance = document.querySelector('#gui-desktop-balance');
    this.betValue = document.querySelector('#gui-desktop-bet-value');
    this.linesValue = document.querySelector('#gui-desktop-lines-value');
    this.betProgress = document.querySelector('#gui-desktop-bet-progress');
    this.linesProgress = document.querySelector('#gui-desktop-lines-progress');
    this.currentBetValue = document.querySelector('#gui-desktop-current-bet-value');

    this.centerRegular = document.querySelector('#gui-desktop-center-regular');
    this.centerDouble = document.querySelector('#gui-desktop-center-double');
    this.doubleStep = document.querySelector('#gui-desktop-double-step');

    this.guiDesktop.hidden = false;
    this.state = 'disabled';
    this.autoGame = false;
    this.double = false;

    this.eventDispatcher = this.eventDispatcher || new createjs.EventDispatcher();

    this.betBtnsDisabled = {
      betDownBtn: true,
      betUpBtn: true,
      linesDownBtn: true,
      linesUpBtn: true,
      maxBetBtn: true,
    };

    this.betUpBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('bet-up'));
    this.betDownBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('bet-down'));
    this.linesUpBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('lines-up'));
    this.linesDownBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('lines-down'));
    this.maxBetBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('bet-max'));

    this.playBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('play'));
    this.autoGameBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('toggle-auto-game'));
    this.autoGameCancelBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('toggle-auto-game'));
    this.stopBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('close-double'));
    this.doubleBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('play-double'));
    this.rulesBtn1.addEventListener('click', () => this.eventDispatcher.dispatchEvent('toggle-rules'));
    this.rulesBtn2.addEventListener('click', () => this.eventDispatcher.dispatchEvent('toggle-rules'));

    window.addEventListener('keydown', (e) => {
      if (e.keyCode !== 32) {
        return;
      }

      e.preventDefault();

      if (!this.playBtn.disabled) {
        this.playBtn.click();
      } else if (!this.stopBtn.disabled) {
        this.stopBtn.click();
      }
    });
  },

  addEventListener(evt, fn) {
    this.eventDispatcher = this.eventDispatcher || new createjs.EventDispatcher();
    this.eventDispatcher.addEventListener(evt, fn);
  },

  // gui
  setState(state) {
    if (this.state === state) {
      return;
    }
    this.state = state;

    const betBtns = [
      this.linesDownBtn,
      this.linesUpBtn,
      this.betDownBtn,
      this.betUpBtn,
      this.maxBetBtn,
    ];

    const btns = [
      this.stopBtn,
      this.doubleBtn,
      this.rulesBtn1,
      this.rulesBtn2,
      this.playBtn,
      this.autoGameBtn,
    ];

    btns.forEach((btn) => {
      btn.disabled = false; // eslint-disable-line no-param-reassign
    });

    switch (state) {
      case 'disabled':
        btns.concat(betBtns).forEach((btn) => {
          btn.disabled = true; // eslint-disable-line no-param-reassign
        });
        break;

      case 'free-ready':
        btns.concat(betBtns).forEach((btn) => {
          btn.disabled = true; // eslint-disable-line no-param-reassign
        });
        this.playBtn.disabled = false;
        break;

      case 'ready':
        this.playBtn.disabled = this.double;
        Object.keys(this.betBtnsDisabled).forEach((key) => {
          this[key].disabled = this.betBtnsDisabled[key];
        });
        break;

      case 'not-ready':
        this.playBtn.disabled = true;
        this.stopBtn.disabled = true;
        this.autoGameBtn.disabled = true;

        Object.keys(this.betBtnsDisabled).forEach((key) => {
          this[key].disabled = this.betBtnsDisabled[key];
        });
        break;

      case 'bet':
        break;

      case 'rules':
        this.playBtn.disabled = true;
        this.stopBtn.disabled = true;
        this.autoGameBtn.disabled = true;
        break;

      case 'can-stop':
        this.playBtn.disabled = true;
        this.autoGameBtn.disabled = true;
        this.rulesBtn1.disabled = true;
        this.rulesBtn2.disabled = true;
        betBtns.forEach((btn) => {
          btn.disabled = true; // eslint-disable-line no-param-reassign
        });
        break;

      default:
        throw new Error('invalid state');
    }

    this.autoGameBtn.hidden = this.autoGame;
    this.autoGameCancelBtn.hidden = !this.autoGame;
  },

  // gui
  setAutoGame(auto) {
    this.autoGame = auto;
    this.autoGameCancelBtn.disabled = !auto;
  },

  // gui
  setDoubleStep(step) {
    this.doubleStep.dataset.step = step + 1;
  },

  // gui
  setDouble(double) {
    this.double = double;
    this.bet.hidden = double;
    this.lines.hidden = double;
    this.centerRegular.hidden = double;
    this.centerDouble.hidden = !double;
  },

  // hud
  setBalance(balance) {
    this.balance.innerText = balance;
  },

  // hud & bet
  setValidState(valid) {
    this.currentBetValue.classList[valid ? 'remove' : 'add']('gui-desktop__field--error');
  },

  // hud & bet
  setBet({
    bet, lines, currentBet, firstBet, lastBet, firstLine, lastLine,
  }) {
    this.betValue.innerText = bet;
    this.linesValue.innerText = lines;
    this.currentBetValue.innerText = currentBet;

    this.betBtnsDisabled = {
      betDownBtn: firstBet,
      betUpBtn: lastBet,
      linesDownBtn: firstLine,
      linesUpBtn: lastLine,
      maxBetBtn: false,
    };

    Object.keys(this.betBtnsDisabled).forEach((key) => {
      this[key].disabled = this.betBtnsDisabled[key];
    });

    const betScale = (this.config.bets.indexOf(bet) + 1) / this.config.bets.length;
    const linesScale = (this.config.lines.indexOf(lines) + 1) / this.config.lines.length;
    this.betProgress.style.transform = `scaleX(${betScale})`;
    this.linesProgress.style.transform = `scaleX(${linesScale})`;
  },

  // bet popup
  isVisible() {
    return false;
  },
};

export default GuiDesktop;




// WEBPACK FOOTER //
// ../base/js/managers/gui-desktop.js